import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { PopupTriggerProps } from '@atlassian/jira-development-board-common/src/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/CommitDetailsPopupViewCommitDetailsPopupViewQuery$parameters';
import type { CommitDetailsPopupViewCommitDetailsPopupViewQuery } from '@atlassian/jira-relay/src/__generated__/CommitDetailsPopupViewCommitDetailsPopupViewQuery.graphql.ts';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const commitDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			commitDetailsForIssue: CommitDetailsPopupViewCommitDetailsPopupViewQuery;
		},
		{},
		PopupTriggerProps,
		{}
	>,
	{
		issueId: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(() => {
		return import(
			/* webpackChunkName: "async-commit-details-popup-new" */ './src/ui/commit-details-popup-view/CommitDetailsPopupView.tsx'
		);
	}),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			commitDetailsForIssue: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueId,
				},
			},
		},
	}),
});
